<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AuU2FH/tc-custom/9781488044625.jpg?1706791132304" alt="This image is the cover for the book Bought Bride for the Argentinian, Conveniently Wed!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bought Bride for the Argentinian, Conveniently Wed!
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: She’ll pose as her sexy ex’s wife to redeem his public reputation—but in private, has he really changed?</b><br/><br/>Alejandro Sabato, the man PR executive Emily Green can’t forget, is back in her life—and has hired her to redeem his playboy reputation. She suggests he take a convenient wife to show he’s changed. What she doesn’t expect is Alejandro’s insistence that she take on the role!<br/><br/>Emily is dangerously aware of the enduring desire still sparking between them. But can she risk her heart again when she’s only a bride on paper?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e033da54